import React from 'react';
import PropTypes from 'prop-types';

import { getChatCompanyId } from '../helper/SessionCookie';

// 회사별 화면 선택.
//
// 화면 계열(Chat·Close·Rating·Expired·Loading)마다 반복되던
// `if (id === '15') … if (id === '17') … if (id === '35') …` 3분기를 대체한다.
// 새 회사가 늘어도 각 라우터의 map 에 한 줄만 더하면 된다.
//
// 나머지 props 는 선택된 화면으로 그대로 전달된다.
const CompanyRouter = ({ map, fallback: Fallback, ...props }) => {
  const companyId = getChatCompanyId();
  const Screen = map[companyId] ?? Fallback;

  return <Screen {...props} />;
};

CompanyRouter.propTypes = {
  // 회사 id → 화면 컴포넌트
  map: PropTypes.objectOf(PropTypes.elementType).isRequired,
  // map 에 없는 회사가 쓸 기본 화면
  fallback: PropTypes.elementType.isRequired,
};

export default CompanyRouter;
